import { MuseumDetails } from "@Interfaces/dddApi.interfaces";
import { createAction, props } from "@ngrx/store";


export const setSingleMuseumDetails = createAction(
  '[SLIM MSM DETAILS] Save single museum slim details',
  props<{ museumDetails: MuseumDetails }>()
);
export const setMultipleMuseumDetails = createAction(
  '[SLIM MUSEUM DETAILS] Save Multiple Museum Slim Details',
  props<{ museumsDetails: { [codesr: string]: MuseumDetails } }>()
);
export const clearSlimMuseumDetails = createAction(
  '[CLEAR][SLIM MUSEUM DETAILS] Clear slim museum details'
);
